import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  getModule,
  markAsCompleteModule,
} from "../../../Services/trainingService";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";
import { COURSE_TOAST_MESSAGES } from "../constants";

export const useCourseModule = (courseId, moduleId) => {
  const [module, setModule] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!courseId || !moduleId) return;

    const fetchModule = async () => {
      setLoading(true);
      try {
        const response = await getModule(courseId, moduleId);
        if (response?.status === 200) {
          setModule(response.data);
        }
      } catch (error) {
        toast.error(
          extractErrorMessage(error) ||
            COURSE_TOAST_MESSAGES.MODULE_FETCH_FAILED,
        );
      } finally {
        setLoading(false);
      }
    };

    fetchModule();
  }, [courseId, moduleId]);

  /* Mark as complete */
  const markComplete = async () => {
    if (!courseId || !moduleId) return;
    setLoading(true);
    try {
      const body = {
        module: moduleId,
        is_completed: true,
        completed_at: new Date().toISOString(),
      };
      await markAsCompleteModule(courseId, moduleId, body);
      setModule((prev) => (prev ? { ...prev, is_completed: true } : prev));
      toast.success(COURSE_TOAST_MESSAGES.MODULE_MARKED_COMPLETE);
      return true;
    } catch (error) {
      toast.error(
        extractErrorMessage(error) ||
          COURSE_TOAST_MESSAGES.MODULE_MARK_COMPLETE_FAILED,
      );
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    module,
    loading,
    markComplete,
  };
};
